import { type ReactNode, type FC } from 'react'
import { Outlet, ScrollRestoration } from 'react-router-dom'
import classnames from 'classnames'
import styles from './styles.module.scss'

type ILayoutProps = {
  sidebarSlot?: ReactNode
}

const Layout: FC<ILayoutProps> = (props) => {
  return (
    <div className={classnames(styles.wrap, 'SM_layout')}>
      {props.sidebarSlot}

      <div className={styles.content}>
        <Outlet />
      </div>

      <ScrollRestoration />
    </div>
  )
}

export default Layout
